import { classNames } from 'libs/react';
import { React } from 'libs/react';
import { useDomain } from 'components/domain/DomainProvider';
import { ProposedOptionsPanel } from './components/ProposedOptionsPanel';
import { StoreProductBlockHeader } from './components/StoreProductBlockHeader';
import { StorePriceSummary } from './components/StorePriceSummary';
import { getPanelOptions, getProposedOptions, setOptionQuantity, toggleSelectedOption } from './StoreProposedOptions';
import './StoreProposedOptionsSection.scss';
import { StoreStepContentHeader } from './components/StoreStepContentHeader';
/**
 * @component StoreProposedOptionsSection
 * @since 1.0.0
 */
export function StoreProposedOptionsSection(props) {
    var _a;
    const { hasDirectSales, lang, saleItems, selectedItems, extrasOnly, nextLabel, processing, onSelectionChange, onNext, onBack } = props;
    const { options } = useDomain();
    const backgroundImage = (_a = options.backgroundImage) !== null && _a !== void 0 ? _a : null;
    const itemsWithOptions = selectedItems
        .map((selectedItem) => {
        const saleItem = saleItems.find((entry) => entry.id === selectedItem.id);
        if (!saleItem) {
            return null;
        }
        const proposedOptions = getProposedOptions(saleItem);
        if (proposedOptions.length === 0) {
            return null;
        }
        const panelOptions = getPanelOptions(saleItem);
        return { selectedItem, saleItem, panelOptions };
    })
        .filter(Boolean);
    function onQuantityChange(productId, quantity) {
        onSelectionChange(selectedItems.map((selectedItem) => selectedItem.id === productId ? Object.assign(Object.assign({}, selectedItem), { quantity }) : selectedItem));
    }
    /**
     * @function onOptionChange
     * @since 1.0.0
     * @hidden
     */
    function onOptionChange(productId, optionItemId, checked) {
        onSelectionChange(selectedItems.map((selectedItem) => {
            if (selectedItem.id !== productId) {
                return selectedItem;
            }
            const saleItem = saleItems.find((entry) => entry.id === productId);
            if (!saleItem) {
                return selectedItem;
            }
            return toggleSelectedOption(saleItem, selectedItem, optionItemId, checked);
        }));
    }
    /**
     * @function onOptionQuantityChange
     * @since 1.0.0
     * @hidden
     */
    function onOptionQuantityChange(productId, optionItemId, quantity) {
        onSelectionChange(selectedItems.map((selectedItem) => selectedItem.id === productId
            ? setOptionQuantity(selectedItem, optionItemId, quantity)
            : selectedItem));
    }
    const className = classNames('section store-proposed-options-section');
    return (React.createElement("div", { className: className, style: {
            backgroundImage: backgroundImage ? `url(${backgroundImage})` : 'none'
        } },
        React.createElement(StoreStepContentHeader, { backDisabled: processing, backgroundImage: backgroundImage, onBack: onBack, title: t('Enhance your experience') }),
        React.createElement("div", { className: "store-proposed-options-section__content" }, itemsWithOptions.map(({ selectedItem, saleItem, panelOptions }) => (React.createElement("div", { key: saleItem.id, className: "store-proposed-options-section__product" },
            React.createElement(StoreProductBlockHeader, { hasDirectSales: hasDirectSales, item: saleItem, lang: lang, quantity: selectedItem.quantity, hideQuantity: extrasOnly, onQuantityChange: extrasOnly
                    ? undefined
                    : (qty) => onQuantityChange(saleItem.id, qty) }),
            React.createElement(ProposedOptionsPanel, { lang: lang, options: panelOptions, productQuantity: selectedItem.quantity, selectedIds: selectedItem.selectedOptionIds, optionQuantities: selectedItem.optionQuantities, onChange: (optionItemId, checked) => onOptionChange(saleItem.id, optionItemId, checked), onQuantityChange: (optionItemId, quantity) => onOptionQuantityChange(saleItem.id, optionItemId, quantity) }))))),
        React.createElement("div", { className: "store-proposed-options-section__footer" },
            React.createElement(StorePriceSummary, { lang: lang, saleItems: saleItems, selectedItems: selectedItems, extrasOnly: extrasOnly, nextLabel: nextLabel, processing: processing, onNext: onNext }))));
}
